// extracted by mini-css-extract-plugin
module.exports = {"block-tags":"block-tags_block-tags__2gWgI","block-title":"block-tags_block-title__d9S5p","link-entry":"block-tags_link-entry__3BKo2","light":"block-tags_light__bYEx_"};